import '../../less/main.less';
import 'react-tippy/dist/tippy.css';
import 'babel-polyfill';
import Route from './route.js';
Route.init();
